import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2083 18.375H4.79167C4.28334 18.375 3.79582 18.1906 3.43638 17.8624C3.07693 17.5342 2.875 17.0891 2.875 16.625V4.375C2.875 3.91087 3.07693 3.46575 3.43638 3.13756C3.79582 2.80937 4.28334 2.625 4.79167 2.625H15.3333L20.125 7V16.625C20.125 17.0891 19.9231 17.5342 19.5636 17.8624C19.2042 18.1906 18.7167 18.375 18.2083 18.375Z",
			stroke: "#2171C6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2916 18.375V11.375H6.70831V18.375",
			stroke: "#2171C6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.70831 2.625V7H14.375",
			stroke: "#2171C6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSave;
